import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../style/Footer.module.css';
import { useCookie } from '../context/CookieContext'; 

function Footer() {
    const currentYear = new Date().getFullYear();
    const { resetCookies } = useCookie(); 

    return (
        <footer className={styles.mainFooter}>
            <div className={styles.footerBackground}>
                <div className={styles.gradientOverlay}></div>
                <div className={styles.patternOverlay}></div>
            </div>

            <div className={styles.footerContent}>
                <div className={styles.footerSections}>
                    {/* Company Information */}
                    <div className={styles.footerSection}>
                        <h3 className={styles.sectionTitle}>
                            <span className={styles.sectionIcon}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                    <polyline points="9,22 9,12 15,12 15,22" />
                                </svg>
                            </span>
                            AWN GmbH
                        </h3>
                        <p className={styles.companyDescription}>
                            Unternehmen stärken mit modernsten KI-Lösungen.
                            Wo Innovation auf Intelligenz trifft und die Zukunft der Technologie transformiert.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className={styles.footerSection}>
                        <h3 className={styles.sectionTitle}>
                            <span className={styles.sectionIcon}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                                </svg>
                            </span>
                            Schnellzugriff
                        </h3>
                        <ul className={styles.footerLinks}>
                            <li><Link to="/chatbot">Chatbot</Link></li>
                            <li><Link to="/dashboard">Anomalie-Erkennungs-Dashboard</Link></li>
                            <li><Link to="/anomaly-detection">Anomalie-Erkennung</Link></li>
                            <li><Link to="/contact">Kontakt</Link></li>
                        </ul>
                    </div>

                    {/* Contact Information */}
                    <div className={styles.footerSection}>
                        <h3 className={styles.sectionTitle}>
                            <span className={styles.sectionIcon}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                </svg>
                            </span>
                            Kontakt
                        </h3>
                        <div className={styles.contactInfo}>
                            <div className={styles.contactItem}>
                                <span className={styles.contactIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                        <circle cx="12" cy="10" r="3" />
                                    </svg>
                                </span>
                                <div>
                                    <p>Konrad-Zuse-Str. 1</p>
                                    <p>84579 Unterneukirchen</p>
                                </div>
                            </div>
                            <div className={styles.contactItem}>
                                <span className={styles.contactIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                    </svg>
                                </span>
                                <div>
                                    <p>+49 (0) 8634 - 624 336</p>
                                </div>
                            </div>
                            <div className={styles.contactItem}>
                                <span className={styles.contactIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                        <polyline points="22,6 12,13 2,6" />
                                    </svg>
                                </span>
                                <div>
                                    <p>info@awn-gmbh.de</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Social Media */}
                <div className={styles.footerMiddle}>
                    <div className={styles.socialSection}>
                        <h3 className={styles.socialTitle}>
                            <span className={styles.sectionIcon}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                    <line x1="9" y1="9" x2="9.01" y2="9" />
                                    <line x1="15" y1="9" x2="15.01" y2="9" />
                                </svg>
                            </span>
                            Folgen Sie uns
                        </h3>
                        <div className={styles.socialLinks}>
                            {/* External links must remain as <a> tags */}
                            <a href="https://www.facebook.com/stromausabgas/" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                                <span className={styles.socialIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                </span>
                                <span>Facebook</span>
                            </a>
                            <a href="https://www.instagram.com/awn.gmbh/" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                                <span className={styles.socialIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                    </svg>
                                </span>
                                <span>Instagram</span>
                            </a>
                            <a href="https://www.linkedin.com/company/awn-gmbh/" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                                <span className={styles.socialIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                    </svg>
                                </span>
                                <span>LinkedIn</span>
                            </a>
                            <a href="https://www.youtube.com/@awngmbh2561" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                                <span className={styles.socialIcon}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                    </svg>
                                </span>
                                <span>YouTube</span>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Footer */}
                <div className={styles.footerBottom}>
                    <div className={styles.bottomContent}>
                        <div className={styles.copyright}>
                            <p>&copy; {currentYear} AWN GmbH. Alle Rechte vorbehalten.</p>
                        </div>
                        <div className={styles.legalLinks}>
                            <Link to="/impressum">Impressum</Link>
                            <span className={styles.separator}>|</span>
                            <Link to="/datenschutz">Datenschutz</Link>
                            <span className={styles.separator}>|</span>
                            <Link to="/nutzungsbedingungen">AGB</Link>
                            <span className={styles.separator}>|</span>
                            
                            {/* GDPR Cookie Reset Button */}
                            <button 
                                onClick={(e) => resetCookies(e)} 
                                style={{ 
                                    background: 'none', 
                                    border: 'none', 
                                    color: 'inherit', 
                                    textDecoration: 'none', 
                                    cursor: 'pointer', 
                                    padding: 0,
                                    font: 'inherit',
                                    fontSize: 'inherit'
                                }}
                                className={styles.footerLink}
                            >
                                Cookie-Einstellungen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;